export default __webpack_public_path__ + "static/media/Jata-Shankar.2a928d1d.jpg";